window.Blimp = window.Blimp || {};

class AppRouter extends Backbone.Router {
  get routes() {
    return {
      'reports(/)(?*querystring)': 'index',
      'reports/:id(/)': 'show',
      'reports/:id/related(/)': 'related',
      'reports/:id/photos/:index(/)': 'zoom'
    };
  }

  initialize() {
    Backbone.history.options = { pushState: true, hashChange: false };
    // Track number of route changes so we know if it's safe to navigate back in history on zoom close
    this.number_of_route_changes = 0;
    Backbone.history.on('route', () => this.number_of_route_changes++);
  }

  index() {
    Blimp.zoom_view.down();
  }

  show(public_id) {
    Blimp.zoom_view.down();
  }

  related(public_id) {
    Blimp.zoom_view.down();
  }

  zoom(public_id, index) {
    const report = Blimp.reports.findWhere({ public_id: public_id });
    Blimp.zoom_view.down();

    const isNumericalIndex = index.length <= 2;
    if (isNumericalIndex) {
      Blimp.zoom_view.up(report, report.photos.at(parseInt(index) - 1)); // e.g. index == 1
    } else {
      Blimp.zoom_view.up(report, report.photos.models.find((e) => e.attributes.public_id === index)); // e.g. index == 2023-05-31-352d9729-3faa-4989-93af-f274e9575745
    }
  }
}

Blimp.AppRouter = AppRouter;

Blimp.init_app = function(options) {
  $.ajaxSetup({ timeout: 5000 });
  moment.locale('en');

  Blimp.s3_url             = options.s3_url;
  Blimp.is_admin           = options.is_admin;
  Blimp.can_edit_comments  = options.can_edit_comments;
  Blimp.can_delete_photos  = options.can_delete_photos;
  Blimp.can_delete_reports = options.can_delete_reports;
  Blimp.is_authenticated   = options.is_authenticated;
  Blimp.feature_group_edit = options.feature_group_edit;
  Blimp.feature_comments   = options.feature_comments;
  Blimp.all_groups         = options.all_groups;

  // Mode
  switch (Blimp.mode = options.mode) {
    case 'search':
      Blimp.reports = new Blimp.ReportsCollection(options.reports, { parse: true });
      Blimp.control_view = new Blimp.ControlView({ el: 'body' });
      break;
    case 'related':
      Blimp.reports = new Blimp.ReportsCollection(options.reports, { parse: true });
      this.groups_view = new Blimp.GroupsView();
      break;
    case 'single':
      Blimp.reports = new Blimp.ReportsCollection([options.report], { parse: true });
      $('.groups').html(new Blimp.ReportView({ model: Blimp.reports.first() }).render().$el);
      break;
  }

  Blimp.zoom_view = new Blimp.ZoomView();
  Blimp.app = new Blimp.AppRouter();
  Backbone.history.start();
};